<template>
  <div id="eventLeftThree" class="echarts"></div>
</template>
<script>
import { defineComponent, reactive, toRefs, onMounted } from "vue";
import * as echarts from "echarts";
import { analyseeventtype } from "@/api/dataAnalysis/eventAnalysis.js";
export default defineComponent({
  name: "",
  components: {},
  props: {},
  setup(props) {
    const data = reactive({
      echartsList: [],
    });
    const refData = toRefs(data);
    const numberall = async () => {
      const res = await analyseeventtype();
      data.echartsList = res.data;
    };
    onMounted(async () => {
      await numberall();
      // echarts项目初始化
      const myChart = echarts.init(document.getElementById("eventLeftThree"));
      myChart.setOption({
        legend: {},
        grid: {
          top: 40,
          left: 70,
          right: 30,
          bottom: 80,
          // containLabel: true
        },
        xAxis: {
          splitLine: {
            // 网格线
            lineStyle: {
              color: "#08598f",
              type: "dashed", // 设置网格线类型 dotted：虚线   solid:实线
            },
            show: true, // 隐藏或显示
            // symbolSize: [0, 30000, 60000, 90000, 120000],
          },
          splitNumber: 5,
          axisLabel: {
            show: true,
            textStyle: {
              color: "#fff",
            },
          },
        },

        yAxis: {
          itemStyle: {
            color: "#326e9a",
            borderColor: "#5ea9d0",
          },
          type: "category",
          data: data.echartsList.map((v) => v.name),
          axisLabel: {
            formatter: "{value}",
            textStyle: {
              color: "#fff",
            },
          },
        },
        series: [
          {
            itemStyle: {
              color: "#326e9a",
              borderColor: "#5ea9d0",
            },
            barGap: 5 /* 多个并排柱子设置柱子之间的间距 */,
            // barWidth: "80%",
            barCateGoryGap: "80%",
            // barWidth: 35,
            type: "bar",
            data: data.echartsList.map((v) => v.value),
          },
        ],
      });
     
     window.addEventListener("resize", () => {
        myChart.resize();
      });
    });
  },
});
</script>
<style lang="scss" scoped>
#eventLeftThree {
  // margin-top: 20px;
  width: 100%;
  height: 100%;
}
</style>
